import { RootState } from '../../store/store';
import { NotificationsState } from '../@types/notifications';

const notificationsSelector = (state: RootState): NotificationsState => state.notifications;

export default notificationsSelector;
